import React from 'react';
import classNames from 'classnames';
import classes from './classes.module.scss';
import AdvisorCta from './advisor_cta';
import AdvisorAvatar, { advisorThemes, advisorThemesDesktopSize } from '../../advisor_avatar';
import TopIcons from '../../advisor_profile_avatar/top_icons';
import ExpandedText from '../../../../common/helpers/expanded_text';
import { isPrerenderMode, getHeaderHeight } from '../../../config/util';
import { isKA } from '../../../../common/config/utils';
import { advisorCtaThemes } from './advisor_cta/advisor_cta_themes';
import AdvisorUrgencySignal from './advisor_urgency_signal';

function AdvisorStaticContainer({
  modesContainerVisible,
  urgentItemVisible,
  profilePictureUrl,
  nickname,
  serviceTitle,
  loading,
  liveModes = [],
  id,
  favoriteAdvisor,
  loader,
  favorite,
  availabilityNotification,
  status,
  profilePictureDetails
}) {
  const renderAvatarSection = () => (
    <div className={ classes.fixedContainerAvatarContainer }>
      <div className={ classes.fixedContainerAvatarHolder } suppressHydrationWarning>
        <AdvisorAvatar
          profilePictureUrl={ profilePictureUrl }
          loading={ loading }
          desktopSize={ advisorThemesDesktopSize.profileSmallAvatar }
          theme={ advisorThemes.profileSmallAvatar }
          profilePictureDetails={ profilePictureDetails }
        />
      </div>
      <div className={ classes.advisorStaticTitleContainer }>
        <div className={ classes.advisorNameContainer } suppressHydrationWarning>
          <ExpandedText
            customClasses={ { text: classes.advisorNameText } }
            ellipsis
          >
            { nickname }
          </ExpandedText>
        </div>

        <div className={ classes.advisorServiceTitleContainer } suppressHydrationWarning>
          <ExpandedText
            customClasses={ { text: classes.advisorServiceTitleText } }
            ellipsis
          >
            { serviceTitle }
          </ExpandedText>
        </div>
      </div>
    </div>
  );

  const renderCtaSection = () => {
    if (loading || isPrerenderMode() || liveModes.length === 0) {
      const skeletonCount = isKA() ? 2 : 3;
      const skeletonClassName = isKA() ? classNames(classes.ctaSkeleton, classes.ctaSkeletonFullWidth) : classes.ctaSkeleton;
      return (
        <div className={ classes.ctaSkeletonContainer }>
          {
            [...Array(skeletonCount)].map((s, index) => (
              <div id={ `ctaSkeleton${ index }` } key={ `ctaSkeleton${ index }` } className={ skeletonClassName } />
            ))
          }
        </div>
      );
    }
    return (
      <div className={ classes.ctaHolder }>
        {liveModes.map((mode) => (
          <AdvisorCta
            key={ mode.mode }
            { ...mode }
            advisorId={ id }
            advisorCallProps={ {
              id,
              name: nickname,
              profilePictureUrl
            } }
            theme={ advisorCtaThemes.advisorFixContainer }
            liveModes={ liveModes }
            isDefaultBottomCTA
          />
        )) }
      </div>
    );
  };

  const renderTopIconContainer = () => (
    <div className={ classes.topIconsContaner }>
      <TopIcons
        id = { id }
        favoriteAdvisor = { favoriteAdvisor }
        favorite = { favorite }
        loader = { loader }
        theme = { advisorThemes.sticky_icons }
        availabilityNotification={ availabilityNotification }
        advisorStatus={ status }
      />
    </div>
  );

  const modesContainerStyle = () => (modesContainerVisible ? { '--display':'none' } : { '--display':'flex', '--top': getHeaderHeight() });
  const urgentItemStyle = () => (urgentItemVisible ? { '--display':'none' } : { '--display':'flex', '--top': getHeaderHeight() });
  const renderContentBrowser = () => (
    <div
      className={ classes.fixedContainerBrowser }
      style={ modesContainerStyle() }
      suppressHydrationWarning
    >
      <div className={ classes.fixedContentBrowser } id="advisorStaticHeader">
        { renderAvatarSection() }
        <div className={ classes.optionsContainer }>
          { renderCtaSection() }
          { renderTopIconContainer() }
        </div>
      </div>
      <div className={ classes.urgentItemContainer } style={ urgentItemStyle() } data-testid="urgency-advisor-header" data-urgent-item-visible={ !urgentItemVisible }>
        <AdvisorUrgencySignal advisorId={ id } isOnline={ status === 'online' } type="advisor_header" loading={ loading } />
      </div>
    </div>
  );

  const renderContentMobile = () => (
    <>
      <div
        className={ classes.fixedTopContainerMobile }
        style={ modesContainerStyle() }
        suppressHydrationWarning
      >
        <div className={ classes.fixedTopContentMobile }>
          { renderAvatarSection() }
          <div className={ classes.optionsContainer }>
            { renderTopIconContainer() }
          </div>
        </div>
      </div>
      <div
        className={ classes.fixedBottomContainerMobile }
        style={ modesContainerStyle() }
        suppressHydrationWarning
        data-testid="fixed-bottom-mobile"
        data-urgent-item-visible={ !urgentItemVisible }
      >
        <AdvisorUrgencySignal advisorId={ id } isOnline={ status === 'online' } type="advisor_cta" loading={ loading } />
        { renderCtaSection() }
      </div>
    </>
  );

  return (
    <>
      {renderContentBrowser()}
      {renderContentMobile()}
    </>
  );
}

export default AdvisorStaticContainer;
